// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging"
import { SuccessToaster } from "../Components/Toaster/Toaster";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDy15e1yOImMPn-Z7NLH4CQ-qtN-VUN264",
  authDomain: "adstreet-firebase-messaging.firebaseapp.com",
  projectId: "adstreet-firebase-messaging",
  storageBucket: "adstreet-firebase-messaging.appspot.com",
  messagingSenderId: "653977702584",
  appId: "1:653977702584:web:b5a7e9e569d9a562da644d",
  measurementId: "G-88G9YREKL9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export const getUserToken = async () => {
  return getToken(messaging,
    // { vapidKey: 'BFalb4dwX6HVjaJwP0pKrUWh94B6SU2UwEhpziLtIyaK-vhUTX53u1rqR6ZfaYMIUO3T4OsI1gV6EOjh38T1u1k' }
    { vapidKey: 'BMMZkMtG1gRF1fPTEzaxC6-mT_maqF-r9Qe8dhM7ptoL29iVHrSw7KUnyZsbAL8ykcXtYLsKznGpfAx3tJ4ji5c' }
  )
    .then((currentToken) => {
      if (currentToken) {
        return currentToken
      }
      else {
        console.log("no auth")
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("🚀 ~ file: firebase.js:40 ~ onMessage ~ payload", payload)
      SuccessToaster("You have a new notification");
      resolve(payload);
    });
  });
